<template>
  <!--编辑诊断结果-->
  <div>
    <Card>
      <Form :model="reportForm" :label-width="120">
        <FormItem label="颈管细胞：">
          <RadioGroup v-model="reportForm.jingguan">
            <Radio label="有">有</Radio>
            <Radio style="margin-left: 20px" label="/">/</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="化生细胞：">
          <RadioGroup v-model="reportForm.huasheng">
            <Radio label="有">有</Radio>
            <Radio style="margin-left: 20px" label="/">/</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="霉菌感染：">
          <RadioGroup v-model="reportForm.meijun">
            <Radio label="有">有</Radio>
            <Radio style="margin-left: 20px" label="/">/</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="菌群转变：">
          <RadioGroup v-model="reportForm.junqun">
            <Radio label="有">有</Radio>
            <Radio style="margin-left: 20px" label="/">/</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem :label="$t('diagnosis.diagnosticResult')">
          <Input v-model="reportForm.diagnoseResult" type="textarea" :autosize="{minRows: 3,maxRows: 3}" :placeholder="$t('diagnosis.diagnosticResult')" >
          </Input>
        </FormItem>
        <FormItem :label="$t('diagnosis.comprehensiveAdvice')">
          <Input v-model="reportForm.recommendation" type="textarea" :autosize="{minRows: 3,maxRows: 3}" :placeholder="$t('diagnosis.diagnosticResultPlaceholder')" >
          </Input>
        </FormItem>
        <FormItem :label="$t('diagnosis.reportDate')">
          <DatePicker v-model="reportForm.reportDate" type="datetime" format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('diagnosis.reportDatePlaceholder')" style="width: 100%"></DatePicker>
        </FormItem>
        <FormItem :label="$t('diagnosis.reportImage')">
          <Input search enter-button :placeholder="$t('diagnosis.reportImagePlaceholder')" :value="reportForm.imagePath" @on-search="onBtnSearch()"/>
        </FormItem>
      </Form>
    </Card>
    <div style="margin-top: 20px">
      <Row>
        <Col span="3" offset="18">
          <Button type="default" size="large" @click="cancelSaveDiagnoseResult()">{{$t('diagnosis.cancel')}}</Button>
        </Col>
        <Col span="3">
          <Button v-if="isSave" type="primary" size="large" @click="saveDiagnoseResult()">{{$t('diagnosis.saveReport')}}</Button>
          <Button v-else type="primary" size="large" @click="saveDiagnoseResult()">{{$t('diagnosis.editReport')}}</Button>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import {formatDate} from '../../../utils/date'
import DrawingImageManagement from '../../case/caseManager/addCase/DrawingImageManagement'
export default {
  name: 'EditDiagnosticResults',
  components: {DrawingImageManagement},
  props: {
    caseId: {
      type: String,
      default: null
    },
    layerUrl: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isSave: true, // 是否为保存
      reportForm: {
        jingguan: '/',
        huasheng: '/',
        meijun: '/',
        junqun: '/',
        diagnoseResult: '', // 诊断结果
        recommendation: '', // 综合建议
        reportDate: new Date(), // 出报告时间，默认当前时间
        imagePath: '' // 出报告时间，默认当前时间
      }
    }
  },
  beforeMount  () {
    this.$vue = this
    if (this.reportForm.imagePath === '') {
      this.reportForm.imagePath = this.layerUrl + '\\Splice\\004006Color.jpg'
    }
    this.getReportDiagnoseResult()
  },
  methods: {
    // 取消保存
    cancelSaveDiagnoseResult () {
      this.$emit('getIsEditDiagnosticResults')
    },
    // 根据病例id获取诊断结果信息
    getReportDiagnoseResult () {
      let params = new URLSearchParams()
      params.append('caseId', this.caseId.toString())
      this.$http.post(this.$vue.getData('GET_REPORT_DIAGNOSE_RESULT_URL'), params).then(suc => {
        if (suc.data.result === '1') {
          this.isSave = false
          let diagnoseResult = suc.data.data
          this.reportForm.diagnoseResult = diagnoseResult.diagnose_result
          this.reportForm.recommendation = diagnoseResult.recommen_dation
          let reportDate = diagnoseResult.report_date
          if (reportDate !== undefined && reportDate !== null && reportDate !== '') {
            this.reportForm.reportDate = reportDate
          } else {
            this.reportForm.reportDate = new Date()
          }
          if (diagnoseResult.image_path !== undefined) {
            this.reportForm.imagePath = diagnoseResult.image_path
          } else {
            this.reportForm.imagePath = this.layerUrl + '\\Splice\\004006Color.jpg'
          }
          if (diagnoseResult.diag_desc) {
            this.parseData(diagnoseResult.diag_desc)
          }
          if (diagnoseResult.micro_desc) {
            this.parseData(diagnoseResult.micro_desc)
          }
        } else {
          this.isSave = true
        }
      })
    },
    // 保存诊断结果
    saveDiagnoseResult () {
      let params = new URLSearchParams()
      params.append('caseId', this.caseId.toString())
      params.append('diagDesc', this.getDiagDesc())
      params.append('microDesc', this.getMicroDesc())
      params.append('diagnoseResult', this.reportForm.diagnoseResult)
      params.append('recommenDation', this.reportForm.recommendation)
      params.append('reportDate', formatDate(this.reportForm.reportDate, 'yyyy-MM-dd hh:mm:ss'))
      params.append('imagePath', this.reportForm.imagePath)
      this.$http.post(this.$vue.getData('SAVE_DIAGNOSE_RESULT_URL'), params).then(suc => {
        if (suc.data.result === '1') {
          this.$Notice.success({
            title: this.$t('caseList.messageNotification'),
            desc: this.$t('diagnosis.addReportResultsSuccess')
          })
          this.$emit('openDiagnosticReport', '0')
        }
      })
    },
    getDiagDesc () {
      return `颈管细胞：${this.reportForm.jingguan}\r\n化生细胞：${this.reportForm.huasheng}`
    },
    getMicroDesc () {
      return `霉菌感染：${this.reportForm.meijun}\r\n菌群转变：${this.reportForm.junqun}`
    },
    parseData (dataStr) {
      // 根据换行符将字符串分割成数组
      let items = dataStr.split('\r\n')
      // 创建一个空的 reportForm 对象
      let reportForm = {}
      // 处理每一个元素
      items.forEach(item => {
        // 根据冒号将每一个元素分割成标签和值
        let [label, value] = item.split('：')
        // 根据标签将值设置到 reportForm 对象中
        switch (label) {
          case '颈管细胞':
            this.reportForm.jingguan = value
            break
          case '化生细胞':
            this.reportForm.huasheng = value
            break
          case '霉菌感染':
            this.reportForm.meijun = value
            break
          case '菌群转变':
            this.reportForm.junqun = value
            break
        }
      })
      return reportForm
    },
    onBtnSearch () {
      let imgName = window.HandleEvent('openName', this.layerUrl)
      console.log('23' + imgName + '213')
      if (imgName !== '' && imgName !== undefined) {
        this.reportForm.imagePath = imgName
      }
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// src/components/base/diagnosis/EditDiagnosticResults.vue